import React from 'react';
import { Col, Row, FormGroup } from 'react-bootstrap';
import { SetupTab } from 'areas/shared/pages/setup';
import { TextAreaBox, Switch, TextBox, UrlBox } from 'fw/forms';
import * as API from 'modules/app/API';
import * as App from 'modules/app/App';
import { Label, ActionButton } from 'fw/components';
import { PhoneBox } from "areas/shared/controls";
import { CommentsGrid } from 'areas/shared/components';
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel'
import AppReviewToolbar from 'areas/admin/certification/shared/AppReviewToolbar';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import * as ReportManager from 'modules/reports/ReportManager';


class CorporateId extends SetupTab {
    initialForm() {
        return {
            phones: [],
            reviewComment: ''
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege('AdminSiteReviewAccess'),
            edit: App.hasPrivilege('AdminSiteReviewAccess')
        }
    }

    urls() {
        return {
            get: API.Admin.url('/siteReview/getCorporate'),
            save: API.Admin.url('/siteReview/saveCorporate')
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
        }
    }

    saveRequest() {
        return {
            siteReviewCorporateId: this.state.form.siteReviewCorporateId,
            certificationId: this.state.form.certificationId,
            certificationKey: this.props.selectedId,
            namePubliclyDisplayed: this.state.form.namePubliclyDisplayed,
            homeBased: this.state.form.homeBased,
            spaceShare: this.state.form.spaceShare,
            otherBusinessName: this.state.form.otherBusinessName,
            primaryBusinessSharingSpace: this.state.form.primaryBusinessSharingSpace,
            spaceShareBusiness: this.state.form.spaceShareBusiness,
            descriptionSpaceShareBusiness: this.state.form.descriptionSpaceShareBusiness,
            rowVersion: this.state.form.rowVersion,
            reviewStatus: this.state.form.reviewStatus,
            reviewComment: this.state.reviewComment
        }
    }

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    isValidated(data) {
        return data.isSubmitted;
    }

    updatePostData = (form, dirty) => {
        this.setState({ form })

        if (dirty === true) this.dirt()
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    ready = () => {
        // If selected form is paper -> Redirect to FinalRecomm
        if (this.state.form.isPaperForm)
            window.location.href = `/admin/siteReview/${this.props.selectedId}/finalRecomm/${this.props.queueTypeCode}`;
    }

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form["reviewStatus"] = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleAppReviewToolbar = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    renderPhoneNumbers = () => {
        return this.state.form.phones.map((p, i) => (
            <div key={p.phoneId} className='form-inline'>
                <PhoneBox value={p} disabled showExtension></PhoneBox>
            </div>
        ));
    };

    checkBlankSpaceShareFields = () => {
        let form = this.state.form;
        if (!this.state.form.spaceShare) {
            form.otherBusinessName = null;
            form.primaryBusinessSharingSpace = null;
            form.spaceShareBusiness = false;
            form.descriptionSpaceShareBusiness = null;
        }

        this.updatePostData(form, true)
    }

    checkBlankSpaceShareBusiness = () => {
        let form = this.state.form;
        if (!this.state.form.spaceShareBusiness) {
            form.descriptionSpaceShareBusiness = null;
        }

        this.updatePostData(form, true)
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "SiteReviewCorporateReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        });

        ReportManager.execute(rq);
    };

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
    }

    addCommentFromSave = (comment) =>{
        if (comment === null) 
            return;
           
        let comments = this.state.form.comments;
                
        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'COR'}
                queueTypeCode={'STR'}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={2}>
                        {this.state.form.showReview ?
                            <AppReviewToolbar
                                queueTypeCode={'STR'}
                                reviewTypeCode={'COR'}
                                comments={this.state.form.comments}
                                onFlagSave={this.handleAppReviewToolbar}
                                certificationKey={this.props.selectedId} />
                            : null}
                    </Col>
                    <Col md={4}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <h3>
                            {this.state.form.siteReviewTitle}
                            {this.renderAdminStepToolbar()}
                            <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>
                        </h3>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Label>Company Name</Label>
                                    <TextBox name="vobName" readonly="true" />
                                </FormGroup>
                                {this.state.form.dba &&
                                    <FormGroup>
                                        <Label>DBA (Doing Business As)</Label>
                                        <TextBox value={this.state.form.dba} readonly="true"></TextBox>
                                    </FormGroup>
                                }
                                <FormGroup>
                                    <Label>Street Address 1</Label>
                                    <TextBox name="street1" readonly="true" />
                                </FormGroup>
                                {this.state.form.street2 &&
                                    <FormGroup>
                                        <Label>Street Address 2</Label>
                                        <TextBox name="street2" readonly="true" />
                                    </FormGroup>
                                }
                                <Row>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label>Zip / Postal Code</Label>
                                            <TextBox name="zip" readonly="true" />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label>State</Label>
                                            <TextBox name="state" readonly="true" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <FormGroup>
                                    <Label>Phone Number(s)</Label>
                                    {this.renderPhoneNumbers()}
                                </FormGroup>
                                <FormGroup>
                                    <Label>Website</Label>
                                    <UrlBox name="website" readonly="true" />
                                </FormGroup>

                                <Label>Is the Firm's name publicly displayed?</Label>
                                <Switch name="namePubliclyDisplayed" labelLeft="No" labelRight="Yes" bsStyle="success" />

                                <Label>Is the Firm Home Based or Office Based?</Label>
                                <Switch name="homeBased" labelLeft="Office Based" labelRight="Home Based" bsStyle="success" />

                                <Label>Does the Applicant share space with any other Firm?</Label>
                                <Switch name="spaceShare" onChange={this.checkBlankSpaceShareFields} labelLeft="No" labelRight="Yes" bsStyle="success" />
                                {this.state.form.spaceShare &&
                                    <React.Fragment>
                                        <FormGroup>
                                            <TextBox required name="otherBusinessName" value={this.state.form.otherBusinessName} placeholder="What is the name of the other Company?" maxLength={500}></TextBox><br />
                                            <TextAreaBox required name="primaryBusinessSharingSpace" placeholder="What is the primary Business of all Firms sharing space?" maxLength={500}></TextAreaBox>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Does the Applicant do Business with any of the Firms sharing space?</Label>
                                            <Switch name="spaceShareBusiness" onChange={this.checkBlankSpaceShareBusiness} labelLeft="No" labelRight="Yes" bsStyle="success" />
                                        </FormGroup>
                                        {this.state.form.spaceShareBusiness &&
                                            <FormGroup>
                                                <TextAreaBox name="descriptionSpaceShareBusiness" required placeholder="Explain the Business conducted with the other Firms" maxLength={500}></TextAreaBox>
                                            </FormGroup>
                                        }
                                    </React.Fragment>
                                }
                            </Col>
                            <Col md={1}></Col>
                            <Col md={5}>
                                <FormGroup>
                                    <Label>Veteran Owner's Full Name</Label>
                                    <TextBox value={this.state.form.veteranOwner.fullName} readonly="true"></TextBox>
                                </FormGroup>
                                <FormGroup>
                                    <Label>Veteran Owner's E-mail</Label>
                                    <TextBox value={this.state.form.veteranOwner.email} readonly="true"></TextBox>
                                </FormGroup>
                                {this.state.form.veteranOwner.phones.length > 0 &&
                                    <FormGroup>
                                        <Label>Veteran Owner's Phone Number(s)</Label>
                                        {this.state.form.veteranOwner.phones.map((phone) => (
                                            <div key={phone.phoneTypeCode + "-" + phone.number} className='form-inline'>
                                                <PhoneBox value={phone} disabled showExtension></PhoneBox>
                                            </div>
                                        ))}
                                    </FormGroup>}

                            </Col>
                        </Row>
                        <Row>
                            <CommentsGrid
                                ref={(c) => { this._commentsGrid = c }}
                                comments={this.state.form.comments}
                                documents={this.state.form.reviewDocuments}
                                certificationKey={this.props.selectedId}
                                reviewTypeCode={"COR"}
                                queueTypeCode={"STR"}
                                enableExport={true}
                                entityId={this.state.form.entityId}
                                readonly={!this.state.privileges.edit || !this.state.enabled}
                                onSave={this.handleCommentsGrid}
                                onCommentChange={this.handleCommentChange} />
                        </Row>
                        {this.state.form.showComplete ?
                            <Row>
                                <ReviewPanel stepName="Corporate ID" onChange={this.handleReviewStatus} reviewStatus={this.state.form.reviewStatus} />
                            </Row>
                        : null}
                    </Col>
                </Row>
            </React.Fragment >
        )
    }
}

export default CorporateId;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/siteReview/siteReviewInfo/corporateId/CorporateId.js